import type { SelectQueryBuilder } from 'kysely'
import { sql } from 'kysely'

/**
 * Excludes soft-deleted rows (deletedAt IS NULL).
 * Use as `.$call(q.notDeleted)` inside subqueries.
 */
export function notDeleted<DB, TB extends keyof DB, O>(
  qb: SelectQueryBuilder<DB, TB, O>,
): SelectQueryBuilder<DB, TB, O> {
  return qb.where('deletedAt' as any, 'is', null)
}

/**
 * Filters for currently active relations:
 * - deletedAt IS NULL
 * - activeTo IS NULL OR activeTo > CURRENT_DATE
 * - activeFrom IS NULL OR activeFrom <= CURRENT_DATE
 *
 * Works with both SQLite and PostgreSQL.
 * Use as `.$call(q.isActive)` inside subqueries.
 */
export function isActive<DB, TB extends keyof DB, O>(qb: SelectQueryBuilder<DB, TB, O>): SelectQueryBuilder<DB, TB, O> {
  return qb
    .where('deletedAt' as any, 'is', null)
    .where(eb => eb.or([eb('activeTo' as any, 'is', null), eb('activeTo' as any, '>', sql`CURRENT_DATE`)]))
    .where(eb => eb.or([eb('activeFrom' as any, 'is', null), eb('activeFrom' as any, '<=', sql`CURRENT_DATE`)]))
}
